<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child" @click.stop="clickOutside">
                    <gofix-card title="Equipment Type" classHeader="pb-19 pl-19" class="mb-0 heig-frame-child contractTree contractPropertyAria" fullContent>
                        <template slot="gofixCard:right_header">
                            <b-button class="mr-3" :disabled="!$checkRole($accessModule.master_equipment_structure, 'delete')" @click="deletEquipsStruct">
                                <div class="tooltip">Delete</div>
                                <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0" />
                                </svg>
                            </b-button>
                            <b-button class="mr-3" :disabled="!$checkRole($accessModule.master_equipment_structure, 'create')" @click="modalEquipStruct">
                                <div class="tooltip">Create</div>
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z" />
                                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z" />
                                </svg>
                            </b-button>
                            <b-dropdown :disabled="!$checkRole($accessModule.master_equipment_structure, 'create')" class="btn" right v-b-tooltip.hover title="Setting">
                                <b-dropdown-item href="#" @click="modals.import = true">Import</b-dropdown-item>
                                <b-dropdown-item href="#">Export action</b-dropdown-item>
                            </b-dropdown>
                        </template>
                        <div class="contenAbsolute">
                            <div class="tree-view-properties">
                                <tree :data="treeData" :options="opts" @node:clicked="selectModel" ref="treeEquipStruct" class="tree-view-properties">
                                    <div slot-scope="{ node }" class="node-container">
                                        <template>
                                            <i @click.stop="popEquipmentStruct(node)" class="icon-pencil list-eq-icon"></i>
                                        </template>
                                        {{ node.text }}
                                    </div>
                                </tree>
                            </div>
                        </div>
                    </gofix-card>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" id="modal-Equipment" :title="titleEquips" hide-footer :centered="true" ref="modal-item-equipmentStruct">
                <b-form>
                    <gofix-form-dropdown 
                        v-if="!isRoot" 
                        label="Node Type" 
                        vLabel="text" 
                        :disabled="disabledType" 
                        v-model="nodeTypeSelected" 
                        :options="nodeType">
                    </gofix-form-dropdown>
                    <gofix-form-input 
                        label="Name" 
                        v-model="$v.equipmentStruct.name.$model" 
                        required></gofix-form-input>
                    <gofix-form-tree 
                        v-if="!isRoot" 
                        label="Parent" 
                        :options="dataparents" 
                        :load-options="loadOptions" 
                        placeholder="" 
                        v-model="nodeParent" 
                        :normalizer="normalizer" 
                        search-nested valueFormat="object">
                    </gofix-form-tree>
                    <gofix-form-tree
                        v-if="!isRoot" label="Category" 
                        :options="categoryItems" 
                        :load-options="loadOptionsService" 
                        v-model="categorySelected" 
                        :normalizer="normalizer" 
                        search-nested valueFormat="object">
                    </gofix-form-tree>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="saveEquipStruct" :loading="disabledCate" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" @hide="hiddenModalImport" title="import file" ref="modal-Import" id="modal-Import" v-model="modals.import" hide-footer>
                <b-form>
                    <b-form-group>
                        <b-form-file @input="chaneFile" :state="isCheck" ref="file-input" accept=".csv" v-model="fileImport">
                            <template slot="file-name" slot-scope="{ names }">
                                <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                            </template>
                        </b-form-file>
                    </b-form-group>
                    <b-button-group class="d-block text-right">
                        <gofix-button label="SUBMIT" @click="importData" :loading="isAction" noBorder></gofix-button>
                    </b-button-group>
                </b-form>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" ref="modal-Remove-equipment">
                <div class="center">Are you sure you want to<br />delete <strong>This Item</strong>?</div>
                <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="$bvModal.hide('modal-Remove')">No</b-button>
                    <b-button class="custom-btn" @click="actionDeteleEquipsStruct">Yes</b-button>
                </b-button-group>
            </b-modal>
        </div>
    </div>
</template>
<script>
import LiquorTree from 'liquor-tree';
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500)
}

export default {
    name: 'equipment-edit',
    components: {
        [LiquorTree.name]: LiquorTree
    },
    data() {
        return {
            disabledSelect: true,
            equipmentStruct: {
                id: 0,
                parent_id: 1,
                node_type: 'equipment_category',
                name: '',
                service_category_id: null
            },
            opts: {
                minFetchDelay: 500,
                fetchData: (node) => {
                    node.isBatch = false
                    if (node.data.id == this.rootID) {
                        return new Promise((resolve, reject) => {
                            resolve([]);
                        });
                    }
                    return new Promise((resolve, reject) => {
                        this.$store.dispatch("EquipmentStructureMasterController/getEquipmentCategory", {
                                id: node.id,
                            })
                            .then(response => {
                                if (response.data.status == 200) {
                                    resolve(response.data.data)
                                }

                            })
                            .catch(error => reject(error));
                    });
                }
            },
            treeData: this.getData(),
            nodeSelected: null,
            nodeUpdate: null,
            disabledModel: false,
            disabledCate: false,
            categorySelected: null,
            categoryItems: [],
            nodeType: [{
                value: 'equipment_category',
                text: 'Equipment Category'
            }, {
                value: 'equipment_type',
                text: 'Equipment Type'
            }],
            disabledType: false,
            dataparents: [],
            replace: function(key, value) {
                switch (key) {
                    case "children":
                        if (value.length > 0) {
                            return value;
                        } else {
                            return null;
                        }
                        break;
                    default:
                        return value;
                }
            },
            nodeParent: null,
            nodeTypeSelected: null,
            rootID: 0,
            isRoot: false,
            titleEquips: 'add equipment type',
            isAction: false,
            modals: {
                import: false
            },
            isCheck: null,
            fileImport: null,
            fileName: 'Click Browse to upload file',
        }
    },
    mixins: [validationMixin],
    validations: {
        equipmentStruct: {
            name: {
                required
            }
        }
    },
    watch: {
        fileImport: function(val, old) {
            if (val) {
                let arrExtionsionAccept = ['csv']
                let extensionArray = val.name.split('.');
                let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                if (!arrExtionsionAccept.includes(extension)) {
                    this.$refs['file-input'].reset()
                    return this.$alertNotification("File format is incorrect. Please select a .csv file!", "danger");
                }
                return this.fileName = val.name;
            }
            return this.fileName = 'Click Browse to upload file'
        }
    },
    mounted() {
        this.$refs.treeEquipStruct.$on('tree:mounted', (data) => {
            this.dataparents = JSON.parse(JSON.stringify(this.$refs.treeEquipStruct.toJSON(), this.replace));
        })
        this.$refs.treeEquipStruct.$on('tree:data:received', (data) => {
            this.dataparents = JSON.parse(JSON.stringify(this.$refs.treeEquipStruct.toJSON(), this.replace));
        })
        this.$refs.treeEquipStruct.$on('node:selected', (data) => {
            this.dataparents = JSON.parse(JSON.stringify(this.$refs.treeEquipStruct.toJSON(), this.replace));
        })
    },
    async created() {
        this.$store.dispatch('EquipmentStructureMasterController/getServiceCategory')
            .then(result => {
                this.categoryItems = result.data.data;
            })
            .catch(error => {
                this.categoryItems = [];
            })
    },
    methods: {
        clickOutside() {
            /*unset select node tree*/
            // let node = this.$refs.treeEquipStruct.selected()
            // node.unselect()

            // this.nodeSelected = null
            // this.equipmentStruct.parent_id = 1
            // this.equipmentStruct.node_type = 'equipment_category'
            // this.disabledSelect = true
        },
        async getData() {
            let response = await this.$store.dispatch("EquipmentStructureMasterController/getEquipmentCategory", {
                id: 0,
            })
            if (response.data.status == 200) {
                this.rootID = (response.data.data && response.data.data.length > 0) ? response.data.data[0].id : 0;
                return response.data.data
            }
            return []
        },
        async selectModel(node) {
            this.isRoot = false;
            if (this.rootID == node.data.id) this.isRoot = true;
            this.nodeSelected = node
            this.equipmentStruct.parent_id = node.data.id
        },
        /*Equipment Struct*/
        modalEquipStruct() {
            this.disabledType = false
            this.nodeTypeSelected = null;
            if (this.$refs.treeEquipStruct.toJSON() === null || this.$refs.treeEquipStruct.toJSON().length == 0) {
                this.disabledType = true
                this.nodeTypeSelected = {
                    value: 'equipment_category',
                    text: 'Equipment Category'
                };
            }
            this.disabledCate = false
            this.disabledSelect = false
            this.categorySelected = null;
            this.nodeParent = null;
            this.nodeUpdate = null
            this.equipmentStruct.id = 0
            this.equipmentStruct.name = ''
            this.isRoot = false;
            if (this.nodeSelected) this.nodeParent = this.nodeSelected.toJSON();
            this.dataparents = (this.$refs.treeEquipStruct.toJSON() === null || this.$refs.treeEquipStruct.toJSON().length == 0) ? [] : JSON.parse(JSON.stringify(this.$refs.treeEquipStruct.toJSON(), this.replace));
            this.titleEquips = 'add equipment type'
            this.$refs['modal-item-equipmentStruct'].show()
        },
        async popEquipmentStruct(node) {
            this.disabledCate = false
            this.titleEquips = 'edit equipment type'
            this.disabledType = (node.data.isBatch && node.data.isBatch === true) ? true : false
            this.nodeTypeSelected = {
                value: 'equipment_type',
                text: 'Equipment Type'
            };
            if (node.data.node_type == 'equipment_category')
                this.nodeTypeSelected = {
                    value: 'equipment_category',
                    text: 'Equipment Category'
                };
            let nodeParent = this.$refs.treeEquipStruct.find({
                data: {
                    id: node.data.parent_id
                }
            });

            if (nodeParent.length) {
                this.nodeParent = nodeParent[0].toJSON();
            }
            this.isRoot = false;
            if (this.rootID == node.data.id) this.isRoot = true;
            this.categorySelected = node.data.service_category;
            this.nodeUpdate = node
            this.nodeSelected = node
            this.equipmentStruct.id = node.data.id
            this.equipmentStruct.name = node.data.name
            this.equipmentStruct.parent_id = node.data.parent_id
            this.equipmentStruct.node_type = node.data.node_type;
            this.dataparents = JSON.parse(JSON.stringify(this.$refs.treeEquipStruct.toJSON(), this.replace));
            if (!this.$checkRole(this.$accessModule.master_equipment_structure, 'create')) {
                return;
            }
            this.$refs['modal-item-equipmentStruct'].show()
        },
        saveEquipStruct() {
            if (this.$refs.treeEquipStruct.toJSON().length > 0) {
                if (!this.nodeTypeSelected && !this.isRoot)
                    return this.$alertNotification("Please select node type", "danger");
                if (!this.nodeParent && !this.isRoot)
                    return this.$alertNotification("Please select parent", "danger");
                if (!this.isRoot) {
                    if ((this.nodeParent.data.node_type == 'equipment_type' && this.nodeTypeSelected.value == 'equipment_type') || (this.nodeParent.data.node_type == 'Root' && this.nodeTypeSelected.value == 'equipment_type') || this.nodeParent.data.node_type == 'equipment_type') {
                        return this.$alertNotification("Please select again", "danger");
                    }
                }
            }

            let method = 'CreateEquipmentStructure'
            let msg = 'Created Equipment Type Response!'
            if (this.equipmentStruct.id != 0) {
                method = 'UpdateEquipmentStructure'
                msg = ''
            }
            if (this.equipmentStruct.name) {
                this.equipmentStruct.name = this.equipmentStruct.name.trim();
            }

            this.equipmentStruct.service_category_id = this.categorySelected ? this.categorySelected.id : null;
            this.equipmentStruct.node_type = this.nodeTypeSelected.value;
            this.equipmentStruct.parent_id = "";
            this.equipmentStruct.node_type = 'Root'
            if (!this.isRoot) {
                this.equipmentStruct.parent_id = (this.nodeParent && this.nodeParent != null) ? this.nodeParent.data.id : 0;
                this.equipmentStruct.node_type = this.nodeTypeSelected.value;
            }

            if (this.nodeParent && this.equipmentStruct.id == this.nodeParent.data.id) {
                return this.$alertNotification("Please select again", "danger");
            }
            if (this.disabledCate) return;
            this.disabledCate = true;
            this.$store.dispatch('EquipmentStructureMasterController/' + method, this.equipmentStruct)
                .then(response => {
                    if (this.isRoot) {
                        this.nodeUpdate.text = this.equipmentStruct.name;
                        this.nodeUpdate.data.name = this.equipmentStruct.name;
                        this.$refs['modal-item-equipmentStruct'].hide();
                        return this.$alertNotification('Update successfully');
                    }

                    if (response.data.status == 200) {
                        this.$nextTick(() => {
                            this.$v.equipmentStruct.$reset()
                            this.$refs['modal-item-equipmentStruct'].hide()
                        })

                        if (msg != '') {
                            if (this.$refs.treeEquipStruct.toJSON().length == 0) {
                                this.$refs.treeEquipStruct.tree.setModel(response.data.data);
                                this.rootID = response.data.data.id
                            } else {
                                let nodeParent = this.$refs.treeEquipStruct.find({
                                    data: {
                                        id: this.equipmentStruct.parent_id
                                    }
                                })

                                if (nodeParent) {
                                    nodeParent[0].data.isBatch = true;
                                    let newNode = nodeParent[0].append({
                                        id: response.data.data.id,
                                        text: response.data.data.name,
                                        data: {
                                            isBatch: false,
                                            id: response.data.data.id,
                                            name: response.data.data.name,
                                            text: response.data.data.text,
                                            parent_id: response.data.data.parent_id,
                                            node_type: response.data.data.node_type,
                                            service_category_id: response.data.data.service_category_id
                                        }
                                    })

                                    nodeParent[0].expand();
                                    newNode.expand();
                                }
                                this.dataparents = JSON.parse(JSON.stringify(this.$refs.treeEquipStruct.toJSON(), this.replace));
                            }
                            return this.$alertNotification(this.$notificationV2('adding', 'master_equipment_structure'));
                        }

                        if (this.nodeUpdate != null) {
                            this.nodeUpdate.data.text = this.equipmentStruct.name
                            this.nodeUpdate.data.name = this.equipmentStruct.name
                            this.nodeUpdate.data.node_type = this.equipmentStruct.node_type
                            this.nodeUpdate.data.parent_id = this.equipmentStruct.parent_id;
                            this.nodeUpdate.data.service_category_id = this.equipmentStruct.service_category_id
                        }
                        if (this.nodeUpdate.parent.data.id != this.equipmentStruct.parent_id) {
                            this.$refs.treeEquipStruct.remove(this.nodeUpdate)
                            let nodeParent = this.$refs.treeEquipStruct.find({
                                data: {
                                    id: this.equipmentStruct.parent_id
                                }
                            })
                            if (nodeParent && nodeParent[0].isBatch == false) {
                                nodeParent[0].data.isBatch = true;
                                let newNode = nodeParent[0].append(this.nodeUpdate)
                                newNode.expand();
                                this.dataparents = JSON.parse(JSON.stringify(this.$refs.treeEquipStruct.toJSON(), this.replace));
                            }
                        }
                        let node = this.$refs.treeEquipStruct.find({
                            data: {
                                id: this.equipmentStruct.id
                            }
                        })
                        if (node && this.nodeSelected != null) {
                            this.nodeSelected = node[0]
                            this.selectModel(this.nodeSelected)
                        }
                        return this.$alertNotification(this.$notificationV2('editing', 'master_equipment_structure'));
                    }
                })
                .catch(error => {
                    this.disabledCate = false
                    if(error.response) this.$alertNotification(error, "danger");
                })
        },
        deletEquipsStruct() {
            if (!this.$checkRole(this.$accessModule.master_equipment_structure, 'create')) {
                return
            }
            if (this.nodeSelected == null) {
                return this.$alertNotification("Please select equipment type before deleting!", "danger");
            }

            if (this.isRoot) return this.$alertNotification("Can't delete node root", "danger");
            this.$refs['modal-Remove-equipment'].show()
        },
        actionDeteleEquipsStruct() {
            this.$store.dispatch('EquipmentStructureMasterController/DeleteEquipmentStructure', this.nodeSelected)
                .then(response => {
                    if (response.data.status == 200) {
                        this.$refs.treeEquipStruct.remove(this.nodeSelected)
                        this.dataparents = JSON.parse(JSON.stringify(this.$refs.treeEquipStruct.toJSON(), this.replace));
                        this.$refs['modal-Remove-equipment'].hide()
                        this.nodeSelected = null;
                        this.$alertNotification(this.$notificationV2('deleting', 'master_equipment_structure'));
                    }
                })
        },
        loadOptionsService({
            action,
            parentNode,
            callback
        }) {
            if (action === LOAD_CHILDREN_OPTIONS) {
                if (parentNode.children) {
                    parentNode.children = parentNode.children;
                    callback();
                    return
                };
                if (parentNode.data.isBatch) {
                    this.$store.dispatch("EquipmentStructureMasterController/getServiceCategory", parentNode.data.id)
                        .then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data;
                                callback();
                            })
                        })
                } else {
                    parentNode.children = []
                    callback();
                }
            }
        },
        loadOptions({
            action,
            parentNode,
            callback
        }) {
            if (action === LOAD_CHILDREN_OPTIONS) {
                if (parentNode.children) {
                    parentNode.children = parentNode.children;
                    callback();
                    return
                };
                if (parentNode.data.isBatch) {
                    this.$store.dispatch("EquipmentStructureMasterController/getEquipmentCategory", {
                            id: parentNode.data.id,
                        })
                        .then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data;
                                callback();
                            })
                        })
                } else {
                    parentNode.children = []
                    callback();
                }
            }
        },
        normalizer(node) {
            if (node.data.isBatch)
                return {
                    id: node.data.id,
                    label: node.text,
                    children: node.children
                }
            return {
                id: node.data.id,
                label: node.text,
                children: undefined
            }
        },
        hiddenModalImport() {
            this.fileImport = null;
            this.isCheck = '';
        },
        chaneFile() {
            this.isCheck = this.fileImport ? false : true
        },
        importData() {
            if (!this.fileImport) {
                return this.$alertNotification("Please choose file to import", "danger");
            }
            this.isAction = true;
            this.$store.dispatch(`EquipmentStructureController/uploadFileImport`, {
                contract_id: 0,
                fileImport: this.fileImport,
                is_master: true
            }).then(result => {
                this.modals.import = false;
                this.isAction = false;
                this.$alertNotification(this.$notificationV2('importing', 'equipment_structure'));
                this.$store.dispatch('EquipmentStructureMasterController/getEquipmentCategory', { id: 0, })
                .then(result => {
                    this.$refs.treeEquipStruct.tree.setModel(result.data.data);
                })
                .catch(error => {})
            })
            .catch(error => {
                this.isAction = false;
                this.$alertNotification("File format is incorrect. Please select a .csv file!", "danger");
            })
        },
    }
}
</script>